<template>
    <b-modal id="editModal" size="md" body-class="px-0" ref="modal" title="Edit Withholding Period" v-model="show"
             @ok="handleSubmit"
             @hide="close"
             @shown="focusPeriodInput">

        <div class="card card-flat mb-0">

            <div class="card-body">

                <div class="form-group">
                    <label>Period</label>
                    <div class="position-relative">
                        <input type="number" ref="periodInput"
                               name="contamination_period"
                               v-validate="{required: true}"
                               class="form-control"
                               v-model="contaminationPeriod"
                               placeholder="Period of Time in Days">

                        <div class="invalid-feedback" v-if="errors.has('contamination_period')">{{ errors.first('contaminationPeriod') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label>Country</label>
                    <div class="position-relative">
                        <VueSelect
                                v-model="country"
                                :options="countries"
                                v-validate="{required: true}"
                                data-vv-name="country_id"
                                data-vv-as="country"
                                placeholder="Country"
                                label="name"
                                track-by="id"
                        >
                        </VueSelect>
                        <div class="invalid-feedback" v-if="errors.has('country_id')">{{ errors.first('country_id') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label>Chemical</label>
                    <div class="position-relative">
                        <VueSelect
                                v-model="chemical"
                                :options="chemicals"
                                v-validate="{required: true}"
                                data-vv-name="chemical_id"
                                data-vv-as="chemical"
                                placeholder="Chemical"
                                label="name"
                                track-by="id"
                        >
                        </VueSelect>
                        <div class="invalid-feedback" v-if="errors.has('chemical_id')">{{ errors.first('chemical_id') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label>Variety Group</label>
                    <div class="position-relative">
                        <VueSelect
                                v-model="varietyGroup"
                                :options="varietyGroups"
                                v-validate="{required: true}"
                                data-vv-name="variety_group_id"
                                data-vv-as="variety group"
                                placeholder="Variety Group"
                                label="name"
                                track-by="id"
                        >
                        </VueSelect>
                        <div class="invalid-feedback" v-if="errors.has('variety_group_id')">{{ errors.first('variety_group_id') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!withholdingPeriod.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="withholdingPeriod.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteWithholdingPeriodMutation from '@views/WithholdingPeriods/EditModal/mutationDeleteWithholdingPeriod.graphql';
import restoreWithholdingPeriodMutation from '@views/WithholdingPeriods/EditModal/mutationRestoreWithholdingPeriod.graphql';
import updateWithholdingPeriodMutation from '@views/WithholdingPeriods/EditModal/mutationUpdateWithholdingPeriod.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: ['close', 'chemicals', 'countries', 'varietyGroups', 'withholdingPeriod'],
  data() {
    return {
      show: true,
      loading: 0,
      contaminationPeriod: this.withholdingPeriod.contamination_period,
      country: this.withholdingPeriod.country,
      chemical: this.withholdingPeriod.chemical,
      varietyGroup: this.withholdingPeriod.varietyGroup,
    };
  },

  methods: {
    handleSubmit() {
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateWithholdingPeriodMutation,
            variables: {
              input: {
                id: this.withholdingPeriod.id,
                contamination_period: this.contaminationPeriod,
                chemical_id: this.chemical.id,
                variety_group_id: this.varietyGroup.id,
                country_id: this.country.id,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateWithholdingPeriod: {
                ...this.withholdingPeriod,
                contamination_period: this.contaminationPeriod,
                chemical_id: this.chemical.id,
                variety_group_id: this.varietyGroup.id,
                country_id: this.country.id,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Withholding Period updated!');
            this.close();
          })
          .catch(err => this.$mapGraphQLError(err))
          .catch(err => {
            console.error(err);
            this.$notifyFailure('Unfortunately, we were unable to do that!',);
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteWithholdingPeriodMutation,
          variables: {
            input: {
              id: this.withholdingPeriod.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Withholding Period disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreWithholdingPeriodMutation,
          variables: {
            input: {
              id: this.withholdingPeriod.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreWithholdingPeriod: {
              ...this.withholdingPeriod,
              id: this.withholdingPeriod.id,
              contamination_period: this.contaminationPeriod,
              chemical_id: this.chemical.id,
              variety_group_id: this.varietyGroup.id,
              country_id: this.country.id,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Withholding Period restored!');
          this.close();
        })
        .catch(err => this.$mapGraphQLError(err))
        .catch(err => {
          console.error(err);
          this.$notifyFailure('Unfortunately, we were unable to do that!',);
        });
    },
    focusPeriodInput() {
      this.$refs.periodInput.focus();
    },
  },
};
</script>
